// extracted by mini-css-extract-plugin
module.exports = {"order":"Order_order__2Q42U"};